<template>
  <div class="candidate avatar-upload">
    <avatar-cropper v-if="isCropping" :image="image" @done="onCropDone" @cancel="cancelCropping"></avatar-cropper>
    <div v-else>
      <input type="file" name="file" ref="file" @change="setFile" style="display: none;" />
      <v-progress-circular :color="themes.candidate.light.input" :size="Number(size) + 8" :width="loading ? 8 : 0"
        :indeterminate="loading">
        <v-avatar @click="$refs.file.click()" style="overflow: hidden; cursor: pointer;" :size="size">
          <img v-img-orientation-changer :src="src" />

          <div v-if="overlay" class="upload-overlay" :class="{ 'on-hover': hoverOverlay }">
            <v-layout align-center fill-height justify-center>
              <div class="white--text text-xs-center">
                <v-icon small color="white">mdi-camera</v-icon><br />
                <span class="font-weight-bold">Update</span>
              </div>
            </v-layout>
          </div>
        </v-avatar>
      </v-progress-circular>
    </div>
  </div>
</template>

<script>
import { createImageFileFromBase64 } from '@/mixins/base64ToImage.js';
import AvatarCropper from './AvatarCropper.vue';

// Vue Component
export default {
  components: {
    AvatarCropper
  },
  props: {
    hoverOverlay: { type: Boolean, default: () => false },
    overlay: { type: Boolean, default: () => false },
    path: { type: String },
    src: { type: String, required: true },
    size: { type: String, default: () => '72' },
  },
  data() {
    return {
      isCropping: false,
      loading: false,
      image: null,
    }
  },
  methods: {
    setFile() {
      this.image = URL.createObjectURL(this.$refs.file.files[0]);
      this.isCropping = true;
    },
    onCropDone(croppedImage) {
      this.image = createImageFileFromBase64(croppedImage, "profile-cropped-image.jpg");
      this.isCropping = false;
      this.submit();
    },
    cancelCropping() {
      this.isCropping = false;
    },
    submit() {
      if (this.image) {
        this.loading = true
        let formData = new FormData()
        formData.append('avatar', this.image)
        this.$http
          .post(this.path, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(
            () => {
              this.$emit('success')
              this.loading = false
              this.$store.dispatch('snackbarSuccess', 'Avatar Saved')
            },
            errors => {
              this.loading = false
              this.$store.dispatch('snackbarError', 'An error occured')
            }
          )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.candidate.avatar-upload {
  .upload-overlay {
    background-color: rgba(0, 0, 0, 0.2);
    bottom: 0px;
    height: 100%;
    position: absolute;
    transition: opacity 0.5s ease;
    width: 100%;

    &.on-hover {
      opacity: 0;
    }

    &.on-hover:hover {
      opacity: 1;
    }
  }
}
</style>
